module.exports = __webpack_public_path__ + "static/media/aleksandra.447249d3.jpg";